function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M11.4102 4.94998C10.9402 2.71998 9.16016 0.919978 6.94016 0.419978C5.01016 -0.010022 3.19016 0.479978 1.84016 1.54998L1.97016 0.899978C2.05016 0.489978 1.79016 0.099978 1.38016 0.019978C0.980156 -0.070022 0.580155 0.199978 0.500156 0.599978L0.0101555 3.05998C-0.0698445 3.45998 0.200156 3.85998 0.600156 3.93998L3.05016 4.42998C3.46016 4.50998 3.85016 4.24998 3.93016 3.83998C4.01016 3.42998 3.75016 3.03998 3.34016 2.95998L2.69016 2.81998C3.67016 1.99998 4.99016 1.56998 6.42016 1.83998C8.16016 2.17998 9.59016 3.55998 9.95016 5.29998C10.5602 8.19998 8.35016 10.76 5.55016 10.76C4.05016 10.76 2.74016 10.02 1.92016 8.88998C1.73016 8.61998 1.38016 8.52998 1.06016 8.63998C1.06016 8.63998 1.05016 8.63998 1.05016 8.64998C0.600156 8.79998 0.400156 9.36998 0.680156 9.75998C1.77016 11.27 3.54016 12.26 5.55016 12.26C9.29016 12.26 12.2302 8.83998 11.4102 4.94998Z",
  fill: "#2196F3"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 11.55,
  height: 12.26,
  fill: "white"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "media/restart-test-icon.3d6c83e1.svg";
export { SvgComponent as ReactComponent };